<mat-dialog-content>
    <mat-card appearance="outlined" class="mat-mdc-elevation-specific mat-elevation-z8">
        <mat-card-header>
            <mat-card-title>
                Create Table
            </mat-card-title>
        </mat-card-header>

        <div class="form-container">
            <form  #tableForm="ngForm">
                <mat-form-field style="width: 400px;">
                    <mat-label>Table Name</mat-label>
                    <input matInput name="tableName" [(ngModel)]="table.name" (keypress)="keyFilter($event)" required (ngModelChange)="tableNameChanged()">
                </mat-form-field>

                <mat-form-field style="width: 400px;">
                    <mat-label>Table Description</mat-label>
                    <input matInput name="tableDescription" [(ngModel)]="table.description" required>
                </mat-form-field>
                <br>
                <ng-container *ngFor="let field of table.fields; let i = index;">
                    <mat-form-field>
                        <mat-label>Column Name</mat-label>
                        <input matInput name="{{i}}" [(ngModel)]="field.name" (keypress)="keyFilter($event)" required>
                        <button mat-button matSuffix color="warn" (click)="removeFieldClicked(i)"><mat-icon>delete</mat-icon></button>
                    </mat-form-field>
                </ng-container>
            </form>
        </div>
    </mat-card>

    <table>
        <tr>
            <td style="width: 33%; text-align: left;">
                <button mat-raised-button color="accent" (click)="addField()" [disabled]="formContainsEmptyFields()">Add Column</button>
            </td>
            <td style="width: 34%; text-align: center;">
                <button mat-raised-button color="accent" [disabled]="!canSave()" (click)="save()">Save</button>
                <button mat-raised-button color="warn" style="margin-left: 10px;" (click)="cancel()">Cancel</button>
            </td>
            <td style="width: 33%; text-align: right;">
                <span style="color: red;">{{errorMessage}}</span>
                <span *ngIf="formContainsDuplicateFields()" style="color: red;">ERROR: There are one or more duplicate field names</span>
            </td>
        </tr>
    </table>
</mat-dialog-content>